/* eslint-disable no-restricted-syntax -- this line was auto generated, hence fix the issue timely */
import React, { useState } from "react";

import { Button, Text, Link, Icon, Title } from "@bookingcom/bui-react";
import { CloseIcon } from "@bookingcom/bui-assets-react/streamline/index.js";
import { useI18n, I18nChildContext, Trans } from "@bookingcom/lingojs-react";
import { t } from "@bookingcom/lingojs-core";

import SearchFiltersDisplayController from "../SearchFiltersDisplayController";
import Frame from "../Frame";
import { useGetAvailableFilters } from "../SearchResults/components/boundsFilterHooks";
import { getFiltersMeta, FilterKey, StoreKeys, FilterMeta } from "../../../constants/filtersMeta";
import { useFiltersReset } from "hooks/useFiltersReset";
import { useAppliedFilters } from "hooks/search/useAppliedFilters";

/*eslint-disable-next-line flights/no-unassigned-todo-comments*/
/**
 * TODO Filters are represented using two different set of keys, think about how to consolidate this.
 */

export type FilterRowProps = {
  filterMeta: FilterMeta;
  resetFilter: (props: StoreKeys[]) => void;
};

export const FilterRow: React.FunctionComponent<FilterRowProps> = ({ filterMeta, resetFilter }) => {
  const i18n = useI18n() as I18nChildContext;
  const { copy, storeKeys } = filterMeta;

  if (!copy || !storeKeys) return null;

  return (
    <Frame direction="row" justifyContent="space-between" alignItems="center">
      <Text variant="body_2">{copy}</Text>
      <Button
        variant="light"
        onClick={() => {
          resetFilter(storeKeys);
        }}
        icon={<Icon svg={CloseIcon} size="small" />}
        attributes={{
          "aria-label": `${i18n.trans(t("flights_filter_reset"))} ${copy}`,
          "data-testid": `search_filters_summary_reset_filter_${storeKeys}`
        }}
      ></Button>
    </Frame>
  );
};

const SearchFiltersSummary: React.FC<{
  isResponsiveFixes?: boolean;
  setDisplayedFiltersCountProp?: React.Dispatch<React.SetStateAction<number>>;
}> = ({ isResponsiveFixes, setDisplayedFiltersCountProp }) => {
  const SHOWN_FILTERS_COUNT_INITIAL = 3;

  const appliedFilters = useAppliedFilters();
  const i18n = useI18n() as I18nChildContext;

  const filtersCount = appliedFilters.length;

  const [displayedFiltersCount, setDisplayedFiltersCount] = useState(SHOWN_FILTERS_COUNT_INITIAL);

  const { filteredTotalCount = 0 } = useGetAvailableFilters();

  const filtersMeta = getFiltersMeta(i18n);

  const { resetFilter, resetAllFilters } = useFiltersReset();

  const showMoreCopy = i18n.trans(t("flights_filters_show_more_action"));
  const showLessCopy = i18n.trans(t("flights_filters_show_less_action"));

  return (
    <>
      {/* Header */}
      <Frame mb={isResponsiveFixes ? 0 : 4}>
        <Frame direction="row" justifyContent="space-between">
          <Title title={i18n.trans(t("flights_filters_title"))} variant="strong_1" titleTagName="h2" />
          {!isResponsiveFixes && filtersCount > 0 && (
            <Link onClick={resetAllFilters} attributes={{ "data-testid": "search_filters_summary_reset_all" }}>
              <Trans tag="flights_filters_reset_all_action" />
            </Link>
          )}
        </Frame>

        <Text
          variant="body_2"
          color="neutral_alt"
          attributes={{ "data-testid": "search_filters_summary_results_number", "aria-live": "polite" }}
        >
          <Trans
            tag="flights_filters_num_results"
            variables={{
              num_results: filteredTotalCount
            }}
            num_exception={filteredTotalCount}
          />
        </Text>
      </Frame>

      {/* Applied filters */}
      {!isResponsiveFixes
        ? appliedFilters.slice(0, displayedFiltersCount).map((filter: FilterKey, index) => (
            <Frame key={index} mb={3}>
              <FilterRow filterMeta={filtersMeta[filter]} resetFilter={resetFilter} />
            </Frame>
          ))
        : null}

      <SearchFiltersDisplayController
        displayedRowsCount={displayedFiltersCount}
        setDisplayedRowsCount={
          isResponsiveFixes && setDisplayedFiltersCountProp ? setDisplayedFiltersCountProp : setDisplayedFiltersCount
        }
        defaultDisplayedRowsCount={SHOWN_FILTERS_COUNT_INITIAL}
        allRowsCount={filtersCount}
        showMoreCopy={showMoreCopy}
        showLessCopy={showLessCopy}
      />
    </>
  );
};

export default SearchFiltersSummary;
